import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { SourceInfoDrawerModal } from "@src/components/organisms/modals/sources-info-drawer-modal/sources-info-drawer-modal";

export const SourceInfoDrawer = () => {
  const showSourceInfoDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.sourceInfoDrawerModal.showModal,
  );

  return <>{showSourceInfoDrawerModal && <SourceInfoDrawerModal />}</>;
};
